export default __webpack_public_path__ + "static/media/stunned_blue.06c81cbe.png";